import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-result-abnormal" }



export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    message: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(__props.type)
    }, null, 2),
    _createElementVNode("p", null, _toDisplayString(__props.message || '没有搜索到符合条件的影片，请换个搜索词后试试吧~'), 1)
  ]))
}
}

})